import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/index';
import ProjectCard from './ProjectCard';
import PsSearch from '../UI/PsSearch';
import {Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const Archive = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ct = useCustomTranslation();
  const [search, setSearch] = useState('');
  const projectInSearch = (project) => (
                                         project.title.toLowerCase().includes(search.toLowerCase()) ||
                                         project.building.toLowerCase().includes(search.toLowerCase())
                                       ) &&
                                       project.archived === true;



  const allProjectsSorted = useSelector(state => actions.getAllProjects(state).sort((a,b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())  );
  const loading = useSelector(state => state.inventory.loading_project );

  useEffect(() => {
    dispatch( actions.initProjects() );
  }, []);

  const countProjectunits = (project) => {
    return (project.projectunits !== undefined)? project.projectunits.length : 0
  }

  let projectlist = <div>leer</div>;

  if ( !loading ) {
    projectlist = allProjectsSorted.map( project => {
      return ( projectInSearch(project) )?
        <ProjectCard
          key={project.id}
          archived={project.archived}
          role={project.role}
          projectId={project.id}
          title={project.title}
          subtitle={project.building}
          countProjectunits={countProjectunits(project)}
          linkTo={'/project/' + project.id}
        /> : ""
    } )
  }

  return (
    <div className="container" style={{maxWidth: "1300px"}} >
      <div className="row justify-content-center">
        <div className="col-lg-11 col-xl-8">
          <div className="page-header">
            <h1>{ ct('archive.title') }</h1>
            <p className="lead"></p>
          </div>

          <ul className="nav nav-tabs nav-fill" role="tablist">
            <li className="nav-item">
              <Link className="nav-link" to="/projects">{ ct('projects.navi.active_projects') }</Link>
            </li>
            <li className="nav-item">
              <div className="nav-link active" role="tab">{ ct('projects.navi.archived_projects') }</div>
            </li>
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade show active" id="tasks" role="tabpanel" data-filter-list="card-list-body">
              <div className="row content-list-head">
                <div className="col-auto"></div>
                <PsSearch
                  onChange={(value) => setSearch(value)}
                  placeholder={ t('common.searchfield.label') }
                  />
              </div>
              <div className="content-list-body">
                  <div className="card-list">
                    <div className="card-list-body projectlist">
                      { projectlist }
                    </div>
                  </div>
              </div>

        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default Archive;



// WEBPACK FOOTER //
// ./src/components/Projects/Archive.js